import { Box, Paper, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { IBookingNote } from "../../../../../../types";

interface NoteProps {
    value: IBookingNote
}

const Note = (props: NoteProps) => {

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack rowGap={2}>
                <Box>
                    <Typography variant="body2">
                        {props.value.creationOperator.username}
                    </Typography>
                    <Typography variant="caption">
                        {dayjs(props.value.creationTimestamp).format('DD-MM-YYYY HH:mm')}
                    </Typography>
                </Box>
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                    {props.value.body}
                </Typography>
            </Stack>
        </Paper>
    )
}

export default Note;
